var _path, _path2, _path3, _path4, _path5, _circle, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVisionIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3",
    "data-name": "Group 3",
    xmlns: "http://www.w3.org/2000/svg",
    width: 81.753,
    height: 80.716,
    viewBox: "0 0 81.753 80.716",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M1767.077,657.313l1.062-7.078,6.274-6.347.245,3.554-.226-.638-.282-2.65,2.2-2.227.462,5.537Z",
    transform: "translate(-1701.384 -641.927)",
    fill: "#525252"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M1790.685,753.741l-9.736,9.85,7.066-1.144,2.493-2.521,2.757-2.789.762-.771.338-.342,1.863-1.885Z",
    transform: "translate(-1714.473 -747.43)",
    fill: "#525252"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M988.071,1257.427a13.247,13.247,0,1,1,7.314-24.293,1.414,1.414,0,1,1-1.564,2.356,10.4,10.4,0,1,0,3.959,4.9,1.414,1.414,0,1,1,2.634-1.029,13.25,13.25,0,0,1-12.343,18.065Z",
    transform: "translate(-953.846 -1197.69)",
    fill: "#525252"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M801.587,1082.09a24.408,24.408,0,1,1,15.395-43.336,1.414,1.414,0,1,1-1.785,2.193,21.549,21.549,0,1,0,4.474,4.969,1.414,1.414,0,1,1,2.368-1.545,24.395,24.395,0,0,1-20.452,37.719Z",
    transform: "translate(-767.361 -1011.198)",
    fill: "#525252"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M637.348,927.674a34.235,34.235,0,1,1,22.4-60.1,1.414,1.414,0,0,1-1.852,2.137,31.38,31.38,0,1,0,4.638,4.99,1.414,1.414,0,0,1,2.267-1.691,34.215,34.215,0,0,1-27.453,54.668Z",
    transform: "translate(-603.122 -846.958)",
    fill: "#525252"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 9.795,
    cy: 9.795,
    r: 9.795,
    transform: "translate(24.469 36.654)",
    fill: "#4a8b2c"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M1199.323,761.912a1.273,1.273,0,0,1-.9-2.167l41.549-42.031a1.273,1.273,0,0,1,1.81,1.789l-41.549,42.031A1.269,1.269,0,0,1,1199.323,761.912Z",
    transform: "translate(-1164.473 -713.08)",
    fill: "#525252"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisionIcon);
export default __webpack_public_path__ + "static/media/vision-icon.d9dcc5e6a3ace10b512c56d5eb09c513.svg";
export { ForwardRef as ReactComponent };